import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelDynamic as _vModelDynamic, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/images/icons/bulb.png'


const _withScopeId = n => (_pushScopeId("data-v-0968ac06"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "h-full relative w-full flex items-center justify-center"
}
const _hoisted_2 = { class: "_register _page-view w-full" }
const _hoisted_3 = {
  key: 0,
  class: "_page-view__title font-bold mb-1 text-neutral-700"
}
const _hoisted_4 = {
  key: 1,
  class: "_page-view__label mb-12 text-neutral-600"
}
const _hoisted_5 = { class: "_page-view__content" }
const _hoisted_6 = { class: "mb-12" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label" }, "Họ và tên", -1))
const _hoisted_8 = {
  key: 0,
  class: "error text-sienna-600"
}
const _hoisted_9 = { class: "mb-12" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label" }, "Mật khẩu", -1))
const _hoisted_11 = ["type"]
const _hoisted_12 = { class: "absolute right-4 top-1/2 pt-1 cursor-pointer text-neutral-600" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M572.52 241.4C518.29 135.59 410.93 64 288 64S57.68 135.64 3.48 241.41a32.35 32.35 0 0 0 0 29.19C57.71 376.41 165.07 448 288 448s230.32-71.64 284.52-177.41a32.35 32.35 0 0 0 0-29.19zM288 400a144 144 0 1 1 144-144 143.93 143.93 0 0 1-144 144zm0-240a95.31 95.31 0 0 0-25.31 3.79 47.85 47.85 0 0 1-66.9 66.9A95.78 95.78 0 1 0 288 160z"
}, null, -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M320 400c-75.85 0-137.25-58.71-142.9-133.11L72.2 185.82c-13.79 17.3-26.48 35.59-36.72 55.59a32.35 32.35 0 0 0 0 29.19C89.71 376.41 197.07 448 320 448c26.91 0 52.87-4 77.89-10.46L346 397.39a144.13 144.13 0 0 1-26 2.61zm313.82 58.1l-110.55-85.44a331.25 331.25 0 0 0 81.25-102.07 32.35 32.35 0 0 0 0-29.19C550.29 135.59 442.93 64 320 64a308.15 308.15 0 0 0-147.32 37.7L45.46 3.37A16 16 0 0 0 23 6.18L3.37 31.45A16 16 0 0 0 6.18 53.9l588.36 454.73a16 16 0 0 0 22.46-2.81l19.64-25.27a16 16 0 0 0-2.82-22.45zm-183.72-142l-39.3-30.38A94.75 94.75 0 0 0 416 256a94.76 94.76 0 0 0-121.31-92.21A47.65 47.65 0 0 1 304 192a46.64 46.64 0 0 1-1.54 10l-73.61-56.89A142.31 142.31 0 0 1 320 112a143.92 143.92 0 0 1 144 144c0 21.63-5.29 41.79-13.9 60.11z"
}, null, -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 0,
  class: "error text-sienna-600"
}
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "input-group__label" }, "Xác nhận mật khẩu", -1))
const _hoisted_19 = {
  key: 0,
  class: "error text-sienna-600"
}
const _hoisted_20 = {
  key: 0,
  class: "mt-6 text-sm w-56"
}
const _hoisted_21 = { class: "error text-sienna-600" }
const _hoisted_22 = { class: "mt-12" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 font-medium text-center absolute bottom-10 w-full flex items-center gap-3 justify-center" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createElementVNode("img", {
      class: "w-6 h-6",
      src: _imports_0,
      alt: ""
    })
  ]),
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Tìm hiểu "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://wiki.luca.education/cac-ban-cap-nhat/website",
      class: "font-semibold text-green-500"
    }, "tính năng mới")
  ])
], -1))
const _hoisted_24 = {
  key: 1,
  class: "_choose-center h-screen w-screen md-down:px-10 px-24 py-30"
}
const _hoisted_25 = {
  key: 0,
  class: "_choose-center__title text-neutral-600 font-semibold mb-12"
}
const _hoisted_26 = { class: "_choose-center__list grid grid-cols-1 lg:grid-cols-2 2xl:grid-cols-3 gap-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ChooseCenterCard = _resolveComponent("ChooseCenterCard")!

  return (!_ctx.chooseCenterStage)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, " Xin chào bạn "))
            : _createCommentVNode("", true),
          false
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " Hãy thiết lập tài khoản của bạn để tiếp tục nhé "))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", {
                class: _normalizeClass(["input-group input--lg", _ctx.errorData.name ? 'error-input' : ''])
              }, [
                _hoisted_7,
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "Họ và tên của bạn",
                  class: "bg-white",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.registerData.name) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.registerData.name]
                ])
              ], 2),
              (_ctx.errorData.name)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorData.name), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", {
                class: _normalizeClass(["input-group input--lg relative", _ctx.errorData.password ? 'error-input' : ''])
              }, [
                _hoisted_10,
                _withDirectives(_createElementVNode("input", {
                  type: _ctx.typePassword,
                  placeholder: "Mật khẩu của bạn",
                  class: "bg-white",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.registerData.password) = $event))
                }, null, 8, _hoisted_11), [
                  [_vModelDynamic, _ctx.registerData.password]
                ]),
                _createElementVNode("div", _hoisted_12, [
                  (_ctx.typePassword === 'text')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 0,
                        height: "16px",
                        "aria-hidden": "true",
                        focusable: "false",
                        "data-prefix": "fas",
                        "data-icon": "eye",
                        class: "svg-inline--fa fa-eye fa-w-18",
                        role: "img",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 576 512",
                        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.typePassword = 'password'))
                      }, _hoisted_14))
                    : _createCommentVNode("", true),
                  (_ctx.typePassword === 'password')
                    ? (_openBlock(), _createElementBlock("svg", {
                        key: 1,
                        height: "16px",
                        "aria-hidden": "true",
                        focusable: "false",
                        "data-prefix": "fas",
                        "data-icon": "eye-slash",
                        class: "svg-inline--fa fa-eye-slash fa-w-20",
                        role: "img",
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 640 512",
                        onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.typePassword = 'text'))
                      }, _hoisted_16))
                    : _createCommentVNode("", true)
                ])
              ], 2),
              (_ctx.errorData.password)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(_ctx.errorData.password), 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", {
                class: _normalizeClass(["input-group input--lg", 
							_ctx.errorData.password_confirmation ? 'error-input' : ''
						])
              }, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  type: "password",
                  placeholder: "Xác nhận mật khẩu",
                  class: "bg-white",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.registerData.password_confirmation) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.registerData.password_confirmation]
                ])
              ], 2),
              (_ctx.errorData.password_confirmation)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, _toDisplayString(_ctx.errorData.password_confirmation), 1))
                : _createCommentVNode("", true)
            ]),
            (_ctx.Error && _ctx.Error?.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.Error), 1)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("button", {
                type: "button",
                class: "button-p btn--lg",
                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
              }, " Hoàn tất ")
            ])
          ])
        ]),
        _hoisted_23
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_24, [
        false
          ? (_openBlock(), _createElementBlock("div", _hoisted_25, " Chọn Cơ Sở để tiếp tục "))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_26, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orgs.filter((o) => o.is_active_org), (org) => {
            return (_openBlock(), _createElementBlock("div", {
              key: org.org_id,
              class: "w-full"
            }, [
              _createVNode(_component_ChooseCenterCard, {
                "data-org": org,
                onSubmit: ($event: any) => (_ctx.selectOrg(org))
              }, null, 8, ["data-org", "onSubmit"])
            ]))
          }), 128))
        ])
      ]))
}